import { z } from 'zod';

/** Current tenant facts, not an installed-tool grant or adoption receipt. */
export const NotesToolDetailsSchema = z.strictObject({
  schema: z.literal('delegate-notes-details/1'),
  workspace: z.strictObject({id:z.string().min(1),name:z.string().min(1),type:z.enum(['personal','business'])}),
  responsibleEmployee: z.strictObject({id:z.string().min(1),name:z.string().min(1),status:z.literal('proposed')}),
  privacy: z.literal('current_user'),
  employeeAccess: z.literal('managed_representative_only'),
  marketplace: z.strictObject({status:z.literal('unverified')}),
  setup: z.strictObject({status:z.literal('not_activated')}),
});
export type NotesToolDetails = z.infer<typeof NotesToolDetailsSchema>;
